import { buildUrl } from './Utils'

export const APPLICANT_FILES = (applicationId: string): string => {
  return buildUrl(`/api/public/applicant_uploads/?application_id=${applicationId} `)
}

export const DELETE_APPLICANT_FILES = (applicationId: string, filesId: string): string => {
  return buildUrl(`/api/public/applicant_uploads/${filesId}/?application_id=${applicationId}`)
}

export const APPLICANT_UPLOAD_URL = (
  applicationId: string,
  applicantId: string,
  fileName?: string
): string =>
  buildUrl(
    `/api/public/applicant_uploads/upload_link/?application_id=${applicationId}&applicant_id=${applicantId}${
      fileName ? `&filename=${fileName}` : ''
    }`
  )
